<template>
  <div class="home">
    <van-nav-bar
      placeholder
      fixed
      border
      left-arrow
      safe-area-inset-top
      left-text="我的订单"
      @click-left="onBackClick"
    />
    <div class="home-page-container">
      <van-tabs @click="handleToggleTab"  v-model="type">
        <van-tab title="待支付" name="created"></van-tab>
        <van-tab title="已支付" name="paid,expired,evaluation"></van-tab>
        <van-tab title="已完成" name="expired,evaluation"></van-tab>
        <van-tab title="已取消" name="cancel"> </van-tab>
      </van-tabs>
      <div class="filter-bar-wrapper">
        <div class="filter-row">
          <div class="label" style="color: #969799;">
            日期：
          </div>
          <div class="value" @click="dateSelectShow = true">
            {{ parseTime(selectDate) }}
            <van-icon name="arrow-down" />
          </div>
        </div>
        <van-popup v-model="dateSelectShow"
                   get-container="body"
                   position="bottom">
          <van-datetime-picker
            :value="currentDate"
            type="month-day"
            title="选择日期"
            :min-date="minDate"
            :max-date="maxDate"
            :formatter="formatter"
            @confirm="onDateConfirm"
            @cancel="dateSelectShow = false"
          />
        </van-popup>
      </div>
      <div class="home-page-content-wrapper">
        <div class="pulldown-bswrapper" ref="bsWrapper">
          <div class="pulldown-scroller">
            <div class="pulldown-wrapper">
              <div v-show="beforePullDown">
                <span>下拉刷新</span>
              </div>
              <div v-show="!beforePullDown">
                <div v-show="isPullingDown">
                  <span>加载中...</span>
                </div>
                <div v-show="!isPullingDown">
                  <span>刷新成功</span>
                </div>
              </div>
            </div>
            <div class="list-wrapper tabbar-bottom-area pulldown-list">
              <order-card v-for="(item,index) in list"
                          :key="index"
                          :list="item"
                          :type="type"
                          @reload="fetchList" />
              <van-empty image="default" description="没有车次" v-if="list.length === 0" />
            </div>
            <div class="pullup-tips" v-if="pagination.page > 1">
              <div v-if="!isPullUpLoad" class="before-trigger">
                <span class="pullup-txt">上拉刷新</span>
              </div>
              <div v-else class="after-trigger">
                <span class="pullup-txt">加载中...</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BScroll from '@better-scroll/core';
import PullDown from '@better-scroll/pull-down';
import PullUp from '@better-scroll/pull-up';
import moment from 'moment';
import { Toast } from 'vant';
import Order from '@/apis/Order';
// eslint-disable-next-line import/extensions
import OrderCard from '@/components/order/OrderCard';

BScroll.use(PullDown);
BScroll.use(PullUp);

// eslint-disable-next-line no-unused-vars
const TIME_BOUNCE = 800;
// eslint-disable-next-line no-unused-vars
const REQUEST_TIME = 1000;
const THRESHOLD = 70;
const STOP = 56;
// eslint-disable-next-line no-unused-vars
const STEP = 0;

export default {
  name: 'OrderList',
  components: {
    OrderCard,
  },
  mounted() {
    this.handleType();
    this.fetchList();
    this.$nextTick(() => {
      this.initScroll();
    });
  },
  data() {
    return {
      dateSelectShow: false,
      value1: 0,
      option1: [
        { text: '筛选', value: 0 },
      ],
      value2: 0,
      option2: [
        { text: '日期', value: 0 },
      ],
      beforePullDown: true,
      isPullingDown: false,
      bscroll: undefined,
      isPullUpLoad: false,
      list: [],
      selectDate: '',
      choosDate:'',
      pagination: {
        page: 1,
        limit: 20,
        total: 0,
      },
      type: 'created',
      
    };
  },
  computed: {
    currentDate() {
      return this.$store.state.currentDate;
    },
    minDate() {
      
      return moment('2021/01/01').toDate();
    },
    maxDate() {
      return moment().add(6, 'days').toDate();
    },
  },
  methods: {
    handleType() {
      if (this.$route.query.type) {
        this.type = this.$route.query.type;
      }
    },
    handleToggleTab(val) {
      this.type = val;
      this.fetchList();
    },
    parseTime(d) {
      if(d){
return moment(d).format('YYYY年MM月DD日');
      }else{
return '筛选时间';
      }
      
    },
    formatter(type, val) {
      if (type === 'month') {
        return `${val}月`;
      }
      if (type === 'day') {
        return `${val}日`;
      }
      return val;
    },
    async onDateConfirm(value) {
       this.selectDate = value;
      this.$store.commit('updateCurrentDate', value);
      this.choosDate = value;
      this.dateSelectShow = false;
      const toast = Toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
      });
      await this.fetchList();
      toast.clear();
    },
    onBackClick() {
  
      this.$router.replace('/');
    },
    onCardClick(item) {
      console.log('Card click ---> ', item);
      this.list=[];
    },
    async fetchList() {
      const { page, limit } = this.pagination;
      const params = {
        page,
        limit,
        ride_date: this.choosDate ? moment(this.choosDate).format('YYYY-MM-DD') : '',
        status: this.type,
      };
      console.log('列表参数》》》', params);
      const res = await Order.getList(params);
      if (Number(res.code) === 0) {
        this.pagination.total = res?.count || 0;
        if (page === 1) {
          this.list = res?.data;
        } else {
          this.list.push(...res?.data);
        }
      }
    },
    initScroll() {
      this.bscroll = new BScroll(this.$refs.bsWrapper, {
        pullUpLoad: true,
        scrollY: true,
        click: true,
        taps: true,
        pullDownRefresh: {
          threshold: THRESHOLD,
          stop: STOP,
        },
      });
      this.bscroll.on('pullingDown', this.pullingDownHandler);
      this.bscroll.on('pullingUp', this.pullingUpHandler);
    },
    async pullingDownHandler() {
      console.log('trigger pullDown');
      this.beforePullDown = false;
      this.isPullingDown = true;
      this.pagination.page = 1;
      // STEP += 1;

      await this.fetchList();

      this.isPullingDown = false;
      await this.finishPullDown();
    },
    async finishPullDown() {
      this.bscroll.finishPullDown();
      setTimeout(() => {
        this.beforePullDown = true;
        this.bscroll.refresh();
      }, TIME_BOUNCE + 100);
    },
    async pullingUpHandler() {
      this.isPullUpLoad = true;
      if (this.pagination.page * this.pagination.limit < this.pagination.total) {
        this.pagination.page += 1;
        await this.fetchList();
      }
      this.bscroll.finishPullUp();
      this.bscroll.refresh();
      this.isPullUpLoad = false;
    },

  },
};
</script>

<style lang="scss" scoped>
.home {
  display: flex;
  flex-direction: column;
  height: 100vh;
  position: relative;
}
.pulldown-bswrapper {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  .pulldown-wrapper {
    position: absolute;
    width: 100%;
    padding: 1.42rem;
    box-sizing: border-box;
    transform: translateY(-100%) translateZ(0);
    text-align: center;
    color: #999;
  }

  .pullup-tips {
    color: #999;
    text-align: center;
    padding: 20px;
  }
}

.list-wrapper {
  padding: .2rem 1rem;
  box-sizing: border-box;
  flex-grow: 1;
  height: 100%;
  /*overflow: auto;*/
}

::v-deep .van-nav-bar__text {
  color: #fff;
}

.home-page-container {
  height: calc(100vh - 46px - 50px);
  display: flex;
  flex-direction: column;
}

.home-page-search {
  flex-shrink: 0;
}

.home-page-content-wrapper {
  flex-basis: 0;
  flex-grow: 1;
  position: relative;
  overflow-y: scroll;
}

.filter-bar-wrapper {
  height: 40px;
  margin-top: 4px;
  //background-color: #fff;
  display: flex;
  align-items: center;
  box-sizing: border-box;
  padding: 0 1.5rem;
  font-family: Sans-serif;
  .filter-row {
    flex-grow: 1;
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    font-weight: 600;
    .label {
      margin-right: 1rem;
    }
    .value {
      cursor: pointer;
    }
  }
}

</style>
<style>

.van-tabs__line{
  width: calc(100% / 3);
  background-color:rgb(26, 107, 69);
}
</style>
